import { render } from "./LootBoxOpenModal.vue?vue&type=template&id=3c2037fc"
import script from "./LootBoxOpenModal.vue?vue&type=script&lang=js"
export * from "./LootBoxOpenModal.vue?vue&type=script&lang=js"

import "./LootBoxOpenModal.vue?vue&type=style&index=0&id=3c2037fc&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__